// extracted by mini-css-extract-plugin
module.exports = {"acc":"Accordion_acc__1zqpl","head":"Accordion_head__2b0yJ","open":"Accordion_open__1eWZ1","caret":"Accordion_caret__KG-P4","body":"Accordion_body__13udW"};